import React from 'react';

function EPOrderBumps() {
  return (
    <div>EPOrderBumps</div>
  );
}

export default EPOrderBumps;
